module.exports = __webpack_public_path__ + "img/dropdown_arrow.0ad5f711.svg";